module.exports = __webpack_public_path__ + "img/Small-Horizontal-Rectangular-Attachment-45.d03f1b21.png";